<template>
  <div>
    <!---------Sélection tags----------->
    <div class="row">
      <div class="col-md-12">
        <small class="text-muted">{{ name }} <span class="text-danger" v-if="isRequired">*</span></small>
      </div>
      <div class="col-md-9">
        <select :id="id" class="form-select form-select-sm" v-model="selected" style="border-radius: 0 !important;">
          <option v-for="option in options" :key="option[index]" :value="option" :disabled="isAlreadyIn(option)">
            <slot name="option" v-bind:option="option">
              {{ option[text] }}
            </slot>
          </option>
        </select>
      </div>
      <div class="col-md-3">
        <b-button :id="`btn-${id}`" size="sm" block :class="{'btn-success': !error, 'btn-danger': error }" style="border-radius: 0 !important;" @click="add">Ajouter</b-button>
      </div>
      <div class="col-md-12">
        <message-error :code="errorCode" :hasError="error"/>
      </div>
    </div>
    <!---------Affichage tags----------->
    <b-card no-body class="my-2" style="border-radius: 0 !important;">
      <div class="row p-3">
        <span class="small" style="opacity: 0.65;">{{ name }}</span> 
        <div class="col-md-12 tags-selected">
          <div class="btn-group mr-2 my-2" role="group" v-for="item in value" :key="item[index]">
            <button type="button" class="btn btn-light btn-sm" >
              {{ item[text] }}
            </button>
            <button type="button" class="btn btn-light btn-sm" @click="remove(item[index])"><i class="fa fa-times" aria-hidden="true"></i></button>
          </div>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import MessageError from '@/core/components/MessageError.vue'

export default {
  name: 'SelectTagsField',
  components: { MessageError },
  props:{
    name: String, 
    value: Array, 
    index: String, 
    text: String, 
    options: Array, 
    isRequired: Boolean,
    error: Boolean,
    errorCode: String,
    id: String
  },
  data(){
    return {
      selected: null,
      itemsSelect: [],
      duplicateError: false
    }
  },
  watch:{
    value(val){
      this.itemsSelect = [...val]
    }
  },
  methods:{
    add(){
      if(!this.isAlreadyIn(this.selected)){
        this.itemsSelect.push(this.selected)
        this.$emit('input',this.itemsSelect)
      }
    },
    isAlreadyIn(item) {
      let isFind =this.value.find(y => y.id === item.id)
      return !!isFind
    },
    remove(id){
      const index = this.itemsSelect.findIndex(isFind => isFind.id === id)
      this.itemsSelect.splice(index, 1);
      this.$emit('input',this.itemsSelect)
    }
  }
}
</script>

<style scoped>

</style>
